import { useMutation, useQuery } from 'react-query'
import axios from 'lib/axiosConfig'
import { SearchProductConfig } from 'types/api/product'

export const usePostSearchProducts = () => {
  return useMutation((values: SearchProductConfig) =>
    axios.post(`/v1/search/products?debug=true`, values)
  )
}

export const useGetCategoryTrees = () => {
  const {
    isLoading,
    error,
    data: response,
  } = useQuery(
    ['getCategoryTrees'],
    async () => axios.get('/v1/category-trees'),
    {
      keepPreviousData: true,
    }
  )

  const categoryTrees =
    response?.data.data.categoryTree.map(
      (category: { categoryTreeName: string }) => {
        return {
          label: category.categoryTreeName,
          value: category.categoryTreeName,
        }
      }
    ) || []
  return { isLoading, error, categoryTrees }
}
